import { generatePath } from 'react-router-dom';

import logger from 'utils/logger.util';

const L = logger('linkTo');

const linkTo = (options) => {
  try {
    return generatePath(options?.pattern, options?.params);
  } catch (e) {
    L.warn('()', e, 'returning', options?.fault, 'for options:', options);
    return options?.fault;
  }
};

// noinspection JSUnusedGlobalSymbols
export default linkTo;
